export default "__VITE_ASSET__CIfkbVoG__"